"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFT_STANDARDS = exports.TokenStandardType = exports.TokenStandardStatus = void 0;
var TokenStandardStatus;
(function (TokenStandardStatus) {
    TokenStandardStatus["Enabled"] = "ENABLED";
    TokenStandardStatus["Disabled"] = "DISABLED";
})(TokenStandardStatus || (exports.TokenStandardStatus = TokenStandardStatus = {}));
var TokenStandardType;
(function (TokenStandardType) {
    TokenStandardType["ASA"] = "ASA";
    TokenStandardType["ERC20"] = "ERC20";
    TokenStandardType["ERC721"] = "ERC721";
    TokenStandardType["ERC20PoolToken"] = "ERC20_POOL_TOKEN";
    TokenStandardType["FungibleCommon"] = "FUNGIBLE_COMMON";
    TokenStandardType["FungibleCommonPool"] = "FUNGIBLE_COMMON_POOL";
    TokenStandardType["NonFungibleUnique"] = "NON_FUNGIBLE_UNIQUE";
})(TokenStandardType || (exports.TokenStandardType = TokenStandardType = {}));
exports.NFT_STANDARDS = [TokenStandardType.ERC721, TokenStandardType.NonFungibleUnique];
